import React from "react";
import { SEPARADOR_PERIODO } from "../helpers/puntosGraficaCierres";

// El periodo en dos líneas, inicio y fin, para que las fechas quepan sin
// inclinarlas
export const TickPeriodoCierre = ({ x, y, payload }) => {
    const [inicio, fin] = payload.value.split(SEPARADOR_PERIODO);

    return (
        <g transform={"translate(" + x + "," + y + ")"}>
            <text textAnchor="middle" fill="#666" fontSize={12}>
                <tspan x={0} dy={14}>
                    {inicio}
                </tspan>
                <tspan x={0} dy={14}>
                    {fin}
                </tspan>
            </text>
        </g>
    );
};
